import { render } from "./MyReg.vue?vue&type=template&id=4ba57be0"
import script from "./MyReg.vue?vue&type=script&lang=js"
export * from "./MyReg.vue?vue&type=script&lang=js"

import "./MyReg.vue?vue&type=style&index=0&id=4ba57be0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__